import React from 'react';

import MarkdownPreview from '@uiw/react-markdown-preview';

import { Icons } from '../../../data/Assets';
import { SVGIcon } from '../../wrappers/SVGIcon';

interface ISuggestionProps {
    title: string;
    description: string;
    disclaimer: string;
    hasSource: boolean;
    isLoading: boolean;
    onEdit: (response: string) => void;
    onSend: (response: string) => void;
    onRegenerate: () => void;
    onShowSources: () => void;
};

const Suggestion = (props: ISuggestionProps) => {
    const { title, description, disclaimer, hasSource, isLoading, onEdit, onSend, onRegenerate, onShowSources } = props;

    return (
        <div className='immersion__immigration_help__suggestions__list__item'>
            {isLoading && <div className='immersion__immigration_help__suggestions__list__item__content immersion__immigration_help__suggestions__list__item__content__loading'>
                <h6 className='immersion__immigration_help__suggestions__list__item__content__loading__title'>Loading response...</h6>
                <i className='immersion__btn_loader' />
            </div>}
            {!isLoading && <div className='immersion__immigration_help__suggestions__list__item__content'>
                <h6 className='immersion__immigration_help__suggestions__list__item__content__title'>{title}</h6>
                {/* <p className='immersion__immigration_help__suggestions__list__item__content__description mice'>{description}</p>
                 */}
                <MarkdownPreview source={description} className='immersion__immigration_help__suggestions__list__item__content__description mice'/>
                <p className='immersion__immigration_help__suggestions__list__item__content__disclaimer mice'>Disclaimer: {disclaimer}</p>
                {hasSource && <button className='immersion__btn immersion__immigration_help__suggestions__list__item__content__source mice' onClick={onShowSources}>View sources</button>}

                <div className='immersion__immigration_help__suggestions__list__item__content__actions'>
                    <button className='immersion__btn immersion__immigration_help__suggestions__list__item__content__actions__edit' onClick={() => onEdit(description)}>
                        <SVGIcon src={Icons.EditFill} hoverColor={'dark_grey'} />
                    </button>

                    <button className='immersion__btn immersion__immigration_help__suggestions__list__item__content__actions__edit' onClick={() => onSend(description)}>
                        <SVGIcon src={Icons.SendFill} hoverColor={'primary'} />
                    </button>
                </div>
            </div>}
            {!isLoading && <button className='immersion__btn immersion__immigration_help__suggestions__list__item__regenerate' onClick={onRegenerate}>
                <SVGIcon src={Icons.Reload} color={'primary'} />
            </button>}
        </div>
    )
}

export default Suggestion;